import { Tag, Tooltip } from "antd"
import { WarningOutlined } from "@ant-design/icons"
import { ILadderPolicy } from "../../types/ladderPolicy.types"
import styles from "./LadderFixedAcosBadge.module.scss"

export const LADDER_STALE_HINT = "ladder snapshot older than 36h"

export function ladderFixedAcosHint(ladderPolicy?: ILadderPolicy): string {
  return `Organic ladder v3: term in top-4 — fixed target ACOS (snapshot ${ladderPolicy?.generatedAt ?? "n/a"})`
}

interface ILadderFixedAcosBadgeProps {
  active: boolean
  ladderPolicy?: ILadderPolicy
}

export function LadderFixedAcosBadge({ active, ladderPolicy }: ILadderFixedAcosBadgeProps) {
  const hint = ladderFixedAcosHint(ladderPolicy)
  return (
    <>
      {active && (
        <Tooltip title={hint}>
          <Tag color="blue" className={styles.badge} aria-label={hint}>
            Fixed · ladder
          </Tag>
        </Tooltip>
      )}
      {ladderPolicy?.stale && (
        <Tooltip title={LADDER_STALE_HINT}>
          <WarningOutlined aria-label={LADDER_STALE_HINT} className={styles.stale} />
        </Tooltip>
      )}
    </>
  )
}
